module.exports = __webpack_public_path__ + "img/station.ea3ec188.svg";